<hub-sub-menu></hub-sub-menu>
<div *ngIf="hub; else loading">
  <div id="machineid">
    <span class="label_plus"><label class="left">serial:</label> {{hub.serial}} </span>
    <span class="label_plus"><label class="right">id:</label> {{hub.hubid}} </span>
    <span class="label_plus">
      <label class="right">machineid:</label> {{hub.machineid}}
      <a *ngIf="!!supersededBy" (click)="gotoSuperseded()"> &nbsp; Superseded by hub {{supersededBy}}</a>
    </span>
    <grafana-link [inHub]="hub"></grafana-link>
  </div>
  <br clear="all" style="height: 1em">
  <hub-information
    [inHub]="hub"
    (information_saved)="onInformationSaved($event)"></hub-information>
  <br clear="all" style="height: 1em">
  <hub-state [inHub]="hub"></hub-state>
  <br clear="all" style="height: 1em">
  <hub-issues [hub]="hub"></hub-issues>
</div>
<ng-template #loading>Fetching data...</ng-template>

